/**
 * Ladekostenzuschuss-Helpers (Issue #200)
 * Validierung + Standardwerte fuer § 3 Nr. 46 EStG Pauschale.
 */

import type { Ladekostenzuschuss } from './database.types';

export const PAUSCHALE_MIT_LADUNG_EUR = 30;
export const PAUSCHALE_OHNE_LADUNG_EUR = 70;

export function standardPauschale(hatArbeitsplatzLadung: boolean): number {
  return hatArbeitsplatzLadung ? PAUSCHALE_MIT_LADUNG_EUR : PAUSCHALE_OHNE_LADUNG_EUR;
}

export interface UeberlappungsKandidat {
  id?: string;
  mitarbeiter_id: string;
  fahrzeug_id: string;
  gueltig_ab: string;
  gueltig_bis: string | null;
}

function toTime(date: string | null, fallback: number): number {
  if (!date) return fallback;
  return new Date(date + 'T00:00:00Z').getTime();
}

export function findeUeberlappung(
  kandidat: UeberlappungsKandidat,
  bestehend: Ladekostenzuschuss[],
): Ladekostenzuschuss | null {
  const neuStart = toTime(kandidat.gueltig_ab, Number.NEGATIVE_INFINITY);
  const neuEnde = toTime(kandidat.gueltig_bis, Number.POSITIVE_INFINITY);

  for (const eintrag of bestehend) {
    if (kandidat.id && eintrag.id === kandidat.id) continue;
    if (eintrag.mitarbeiter_id !== kandidat.mitarbeiter_id) continue;
    if (eintrag.fahrzeug_id !== kandidat.fahrzeug_id) continue;

    const bStart = toTime(eintrag.gueltig_ab, Number.NEGATIVE_INFINITY);
    const bEnde = toTime(eintrag.gueltig_bis, Number.POSITIVE_INFINITY);

    if (neuStart <= bEnde && bStart <= neuEnde) {
      return eintrag;
    }
  }
  return null;
}

export interface LadekostenzuschussEingabe {
  mitarbeiter_id: string;
  fahrzeug_id: string;
  hat_arbeitsplatz_ladung: boolean;
  pauschale_eur: number;
  gueltig_ab: string;
  gueltig_bis: string | null;
}

export interface ValidierungsErgebnis {
  valid: boolean;
  error?: string;
}

export function validiereLadekostenzuschussEingabe(
  eingabe: LadekostenzuschussEingabe,
): ValidierungsErgebnis {
  if (!eingabe.mitarbeiter_id) {
    return { valid: false, error: 'Mitarbeiter ist erforderlich' };
  }
  if (!eingabe.fahrzeug_id) {
    return { valid: false, error: 'Fahrzeug ist erforderlich' };
  }
  if (!eingabe.gueltig_ab) {
    return { valid: false, error: 'gueltig_ab ist erforderlich' };
  }
  if (!Number.isFinite(eingabe.pauschale_eur) || eingabe.pauschale_eur < 0) {
    return { valid: false, error: 'Pauschale muss >= 0 sein' };
  }
  if (eingabe.gueltig_bis) {
    const ab = new Date(eingabe.gueltig_ab).getTime();
    const bis = new Date(eingabe.gueltig_bis).getTime();
    if (bis < ab) {
      return { valid: false, error: 'gueltig_bis liegt vor gueltig_ab (ungueltiger Zeitraum)' };
    }
  }
  return { valid: true };
}
